import React from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';

export default ({
  headers,
  rows,
  renderRow,
  options = {
    selectable: false,
  },
  onRowSelection,
}) => {
  const adjustForCheckbox = options.selectable;

  if (rows) {
    return (
      <Table
        selectable={options.selectable}
        multiSelectable={options.multiSelect}
        onRowSelection={onRowSelection}
      >
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={adjustForCheckbox}
        >
          <TableRow>
            {headers.map(header => (
              <TableHeaderColumn key={header}>{header}</TableHeaderColumn>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody
          displayRowCheckbox={options.selectable}
          deselectOnClickaway={false}
        >
          {rows.map(renderRow)}
        </TableBody>
      </Table>
    );
  }

  return <span>No Data Found</span>;
};



// WEBPACK FOOTER //
// ./src/modules/components/Grid.js